'use client';

import Image from "next/image";
import { lazy, useState } from "react";
import Title from "../Title";
import ChancellerImg from '@/assets/image/Our-Commitment-to-Real-World-Skills.webp';

const VideoModal = lazy(() => import('@/components/videoModel'));

const ChancellorSection = ({ data, loading }) => {
  const [modal, setModal] = useState({ open: false, url: "" });

 
  const heading = data?.Title || "";
  const subText = data?.Description || "";
  const blocks = data?.PartnershipBlocks || [];

  // Works for Strapi v5 and v4 (handles both media shapes)
  const getMediaUrl = (media) => {
    const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || "http://localhost:1337";
    const url =
      media?.url ||                          // Strapi v5 often
      media?.data?.attributes?.url ||        // Strapi v4
      media?.data?.url;                      // Alternative Strapi shape

    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  if (loading && !data) {
    return (
      <section className="w-full top_bottom_space">
        <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
          <div className="animate-pulse">
            <div className="h-7 w-[80%] bg-gray-200 rounded mb-3" />
            <div className="h-4 w-[90%] bg-gray-200 rounded mb-2" />
            <div className="h-4 w-[70%] bg-gray-200 rounded" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full top_bottom_space">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="w-full heading_space_bottom">
          <Title
            heading={heading}
            subText={subText}
            color="text-black"
            subTextColor="text-black/70"
            align="text-left"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.8fr_2fr] gap-2 md:gap-4 bg-white">
          <VideoModal
            open={modal.open}
            url={modal.url}
            onClose={() => setModal({ open: false, url: "" })}
          />

          {/* Left big card (kept as your static one) */}
          <div className="relative overflow-hidden shadow-md">
            <Image src={ChancellerImg} alt="Chancellor" className="w-full h-full object-cover" />

            <div className="absolute inset-0 flex items-center justify-center z-20">
              {blocks
                .filter((b) => b?.BlockType === "Video")
                .map((block) => (
                  <button
                    key={block.id}
                    onClick={() => setModal({ open: true, url: block.videoUrl })}
                    className="flex justify-center items-center cursor-pointer w-12 h-12 md:w-14 md:h-14 rounded-full
                  bg-white text-[#081E2D] p-3 shadow-lg hover:scale-105 transition"
                  >
                    <Image src="/play.svg" alt="Play" width={18} height={22} className="ml-1.5" />
                  </button>
                ))
              }

            </div>

            <div
              className="absolute inset-0 z-10"
              style={{ background: "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)" }}
            />

            <div className="absolute bottom-2 left-5 right-0 z-20 text-white p-1 md:p-4">
              <p className="text-[clamp(13px,1.2vw,20px)] font-semibold">
                {blocks.find((b) => b?.BlockType === "Video")?.ImageDescription}
              </p>
            </div>
          </div>

          {/* Right 2x2 cards from Strapi PartnershipBlocks */}
          <div className="grid grid-cols-2 grid-rows-2 gap-2 md:gap-4 overflow-hidden">
            {blocks
              .filter((b) => b?.BlockType === "Image")  // only image blocks
              .slice(0, 4)                               // show first 4 like your UI
              .map((block) => {
                const imgUrl = getMediaUrl(block?.Image);
                return (
                  <div key={block?.id} className="relative overflow-hidden shadow-md group">
                    {imgUrl ? (
                      <Image
                        src={imgUrl}
                        alt={block?.ImageDescription || "Partnership"}
                        fill
                        quality={60}
                        className="object-cover transition-transform duration-500 group-hover:scale-110"
                        
                         sizes="(max-width: 768px) 50vw, 388px"
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-200" />
                    )}

                    <div
                      className="absolute inset-0 z-10"
                      style={{ background: "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)" }}
                    />

                    <div className="absolute bottom-1 left-1 right-0 z-20 text-white p-2 md:p-4">
                      <p className="text-white text-[12px] md:text-[14px] font-semibold">
                        {block?.ImageDescription}
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChancellorSection;
